import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=122d1a86&scoped=true&"
var script = {}
import style0 from "./Main.vue?vue&type=style&index=0&id=122d1a86&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122d1a86",
  null
  
)

component.options.__file = "Main.vue"
export default component.exports